import { Link } from "react-router-dom";
import { Button, Container, Input, Rows } from "rothzerg-ui";
import {
  footerColumns,
  footerQuickLinks,
  footerSocialLinks,
  paymentMethods,
} from "@/data/navigation";

export function SiteFooter() {
  return (
    <footer id="site-footer">
      <div className="kmart-footer-newsletter">
        <Container>
          <Rows gap="md">
            <h3 style={{ margin: 0 }}>Sign up for exclusive offers</h3>
            <form
              id="footer-newsletter-form"
              style={{ display: "flex", gap: "0.5rem", maxWidth: 480 }}
              onSubmit={(e) => e.preventDefault()}
            >
              <Input id="footer-newsletter-email" placeholder="Enter your email" type="email" />
              <Button type="submit" variant="secondary">
                Sign up
              </Button>
            </form>
          </Rows>
        </Container>
      </div>

      <Container>
        <div style={{ padding: "2rem 0", display: "flex", gap: "2rem", flexWrap: "wrap" }}>
          {footerQuickLinks.map((link) => (
            <Link key={link.label} to={link.href}>
              {link.label}
            </Link>
          ))}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: "2rem",
            paddingBottom: "2rem",
          }}
        >
          <div id="footer-social-links">
            <strong>Get Social</strong>
            <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
              {footerSocialLinks.map((link) => (
                <a key={link.label} href={link.href}>
                  {link.label}
                </a>
              ))}
            </div>
            <p style={{ fontSize: "0.875rem", marginTop: "1rem" }}>Download the free Kmart App</p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <strong>{col.title}</strong>
              <ul style={{ listStyle: "none", padding: 0, margin: "0.5rem 0 0" }}>
                {col.links.map((link) => (
                  <li key={link.label} style={{ marginBottom: "0.35rem" }}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div id="footer-payment-methods" style={{ paddingBottom: "1.5rem" }}>
          {paymentMethods.map((method) => (
            <span
              key={method}
              style={{
                display: "inline-block",
                marginRight: "0.75rem",
                padding: "0.25rem 0.5rem",
                border: "1px solid var(--rz-color-border)",
                borderRadius: 4,
                fontSize: "0.75rem",
              }}
            >
              {method}
            </span>
          ))}
        </div>
      </Container>

      <div
        style={{
          background: "#1a2744",
          color: "#fff",
          padding: "1rem",
          textAlign: "center",
          fontSize: "0.8125rem",
        }}
      >
        <span className="kmart-logo" style={{ color: "#fff" }}>
          Kmart
        </span>
        <p style={{ margin: "0.5rem 0 0" }}>© {new Date().getFullYear()} Kmart Australia. All rights reserved.</p>
      </div>
    </footer>
  );
}
